import React, { useState, useEffect } from 'react'
import AppBar from '../components/AppBar'
import { noticeApi, type Notice } from '../api/notice'
import Gap from '../components/Gap'

const NoticePage: React.FC = () => {
  const [notices, setNotices] = useState<Notice[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const [expandedIds, setExpandedIds] = useState<Set<string>>(new Set())

  useEffect(() => {
    const fetchNotices = async () => {
      setIsLoading(true)
      try {
        const response = await noticeApi.getNotices()
        setNotices(response.notices)
      } catch (error) {
        console.error('공지사항을 불러오는데 실패했습니다.', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchNotices()
  }, [])

  const toggleNotice = (id: string) => {
    const newExpandedIds = new Set(expandedIds)
    if (newExpandedIds.has(id)) {
      newExpandedIds.delete(id)
    } else {
      newExpandedIds.add(id)
    }
    setExpandedIds(newExpandedIds)
  }

  return (
    <div className="w-full h-full flex flex-col">
      <AppBar title="공지사항" isBottomBorder />

      <div className="app-container flex-1 min-h-0 flex flex-col">
        <div className="flex-1 overflow-y-auto scrollbar-hide">
          {isLoading ? (
            <div className="flex items-center justify-center py-40px">
              <span className="text-style-body1 text-textColorText2">
                로딩 중...
              </span>
            </div>
          ) : notices.length === 0 ? (
            <div className="h-full flex items-center justify-center empty-state-center">
              <span className="text-style-body1 text-textColorText3">
                공지사항이 없습니다.
              </span>
            </div>
          ) : (
            notices.map((notice, index) => {
              const isExpanded = expandedIds.has(notice.id)
              const isLast = index === notices.length - 1

              return (
                <div
                  key={notice.id}
                  className={`${
                    !isLast ? 'border-b border-brandPrimary-20%' : ''
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggleNotice(notice.id)}
                    className="w-full flex flex-col items-start justify-between py-16px px-20px hover:bg-brandPrimary-5% active:bg-brandPrimary-10%"
                  >
                    <div className="w-full flex items-center justify-between">
                      <span className="flex-1 font-pretendard font-bold text-16px leading-24px text-brown-80%-main text-left">
                        {notice.title}
                      </span>
                      <Gap width={8} />
                      <div className="flex-shrink-0 ml-12px">
                        {isExpanded ? (
                          <img
                            src="/images/chevron-right-icon.png"
                            alt="접기"
                            className="w-24px h-24px object-contain"
                            style={{ transform: 'rotate(-90deg)' }}
                          />
                        ) : (
                          <img
                            src="/images/chevron-right-icon.png"
                            alt="펼치기"
                            className="w-24px h-24px object-contain"
                            style={{ transform: 'rotate(90deg)' }}
                          />
                        )}
                      </div>
                    </div>

                    <Gap height={8} />

                    <span className="font-pretendard font-regular text-14px leading-140% text-textColorText3">
                      {notice.date}
                    </span>
                  </button>

                  {isExpanded && (
                    <div className="px-20px pt-8px pb-16px bg-bgPrimary">
                      <div className="font-pretendard font-regular text-14px leading-180% text-textColorText2 leading-relaxed whitespace-pre-wrap">
                        {notice.content}
                      </div>
                    </div>
                  )}
                </div>
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}

export default NoticePage
